import {
    ADD_GENERIC_CODEBOOK_ERROR,
    ADD_GENERIC_CODEBOOK_PENDING,
    ADD_GENERIC_CODEBOOK_SUCCESS,
    FILTER_GENERIC_CODEBOOK,
    GENERIC_CODEBOOK_DELETED,
    GET_GENERIC_CODEBOOK_ERROR,
    GET_GENERIC_CODEBOOK_PENDING,
    GET_GENERIC_CODEBOOK_SUCCESS,
    RESET_GENERIC_CODEBOOK_STATE,
    SET_GENERIC_CODEBOOK_OPTIONS_MAP,
    SHOW_ADD_MODAL_GENERIC_CODEBOOK,
    SHOW_EDIT_MODAL_GENERIC_CODEBOOK,
    UPDATE_GENERIC_CODEBOOK_ERROR,
    UPDATE_GENERIC_CODEBOOK_PENDING,
    UPDATE_GENERIC_CODEBOOK_SUCCESS
} from "./types";
import {message, Modal} from "antd";
import api from "../../api/api";
import HttpResponseStatus from "../../constants/HttpResponseStatus";
import DataType from "../../constants/DataType";

const resetGenericCodebookState = () => ({
    type: RESET_GENERIC_CODEBOOK_STATE
});

const getGenericCodebookData = (getUrl, columns) => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    const optionsMap = getState().genericCodebook.optionsMap;

    try {
        dispatch({type: GET_GENERIC_CODEBOOK_PENDING});

        let i = 0;
        const {data} = await api.get(getUrl);
        data.map(item => {
            item.multiselectCol = 1;
            i++;
            if (i === 2) {
                item.multiselectCol = 2;
            }
            return item;
        });
        const selectColumns = columns.filter(kol => kol.type === DataType.SELECT);
        if (selectColumns.length === 0) {
            dispatch({type: GET_GENERIC_CODEBOOK_SUCCESS, payload: data});
        } else {
            selectColumns.forEach(async col => {
                if (col.optionsLinkFetch) {
                    try {
                        const resp = await api.get(col.optionsLinkFetch);
                        let newOptionsMap = [...optionsMap];
                        newOptionsMap.push({
                            key: col.key,
                            options: resp.data.map(i => ({...i, value: i[col.displayColumn]}))
                        });
                        dispatch(setGenericCodebookOptionsMap(newOptionsMap));
                        dispatch({type: GET_GENERIC_CODEBOOK_SUCCESS, payload: data});
                    } catch (e) {
                        console.log('error');
                    }
                } else if (col.optionsData) {
                    dispatch(setGenericCodebookOptionsMap([{key: col.key, options: col.optionsData}]));
                }
            });
        }
    } catch (exc) {
        if (exc.response.status === HttpResponseStatus.UNAUTHORIZED) {
            message.error({
                content: 'An error has occurred while loading data. Data is Forbidden.',
                className: darkMode && "dark-mode"
            });
        } else {
            message.error({
                content: 'An error has occurred while loading data.',
                className: darkMode && "dark-mode"
            });
        }
        dispatch({type: GET_GENERIC_CODEBOOK_ERROR, payload: exc})
    }
};

const setGenericCodebookOptionsMap = optionsMap => ({
    type: SET_GENERIC_CODEBOOK_OPTIONS_MAP,
    payload: optionsMap
});

const computeFilters = (filtersMap, column, type, value) => {
    const filter = filtersMap.find(filter => {
        return filter.key === column.key;
    });

    if (filter) {
        const newFilter = {...filter};
        newFilter.value = value;

        const foundIndex = filtersMap.findIndex(filter => {
            return filter.key === column.key;
        });

        if (foundIndex !== -1) {
            let newFiltersMap = [...filtersMap];
            newFiltersMap[foundIndex] = newFilter;
            return newFiltersMap;
        }
    } else {
        const newFilter = {key: column.key, value: value, type: type};
        return [...filtersMap, newFilter];
    }
};

const setFiltersAndFilterData = (column, type, value) => async (dispatch, getState) => {
    const oldFiltersMap = getState().genericCodebook.filtersMap;
    const data = getState().genericCodebook.data;

    const filtersMap = computeFilters(oldFiltersMap, column, type, value);

    const filteredData = data.filter(item => {
        let shouldShowItem = true;
        filtersMap.forEach(fMap => {
            if (fMap.type === DataType.SELECT || fMap.type === DataType.MULTI_SELECT) {
                if (fMap.value && item[fMap.key] !== fMap.value)
                    shouldShowItem = false;
            } else if (item[fMap.key] && item[fMap.key].toLowerCase().indexOf(fMap.value?.toLowerCase()) === -1)
                shouldShowItem = false;
        });
        return shouldShowItem;
    });

    dispatch({
        type: FILTER_GENERIC_CODEBOOK,
        payload: {
            filtersMap: filtersMap,
            filteredData
        }
    });
};

const toggleGenericCodebookAddModal = visible => ({
    type: SHOW_ADD_MODAL_GENERIC_CODEBOOK,
    payload: visible
});

const toggleGenericCodebookEditModal = (editModalVisible, editItemInitialObject) => ({
    type: SHOW_EDIT_MODAL_GENERIC_CODEBOOK,
    payload: {
        editModalVisible,
        editItemInitialObject
    }
});

const saveGenericCodebook = (requestObj, linkAdd) => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    try {
        dispatch({type: ADD_GENERIC_CODEBOOK_PENDING});
        const {data} = await api.post(linkAdd, requestObj);
        message.success({
            content: "Item successfully added",
            className: darkMode && "dark-mode"
        });
        dispatch({type: ADD_GENERIC_CODEBOOK_SUCCESS, payload: data});
    } catch (error) {
        if (error.response.status === HttpResponseStatus.CONFLICT) {
            message.error({
                content: error.response.data,
                className: darkMode && "dark-mode"
            });
        } else {
            message.error({
                content: "Error while adding new item",
                className: darkMode && "dark-mode"
            });
        }
        dispatch({type: ADD_GENERIC_CODEBOOK_ERROR, payload: error});
    }
};

const updateGenericCodebook = (requestObj, link) => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    const data = getState().genericCodebook.data;
    try {
        dispatch({type: UPDATE_GENERIC_CODEBOOK_PENDING});
        const response = await api.put(link + '/' + requestObj.id, requestObj);
        message.success({
            content: "Item successfully updated",
            className: darkMode && "dark-mode"
        });

        let newData = [...data];
        let index = newData.findIndex(item => {
            return item.id === requestObj.id;
        });
        newData[index] = response.data;

        dispatch({type: UPDATE_GENERIC_CODEBOOK_SUCCESS, payload: newData});
    } catch (error) {
        message.error({
            content: "Error on item update",
            className: darkMode && "dark-mode"
        });
        dispatch({type: UPDATE_GENERIC_CODEBOOK_ERROR, payload: error});
    }
};

const onGenericCodebookDelete = (record, link) => async (dispatch, getState) => {
    const darkMode = getState().theme.darkMode;
    const data = getState().genericCodebook.data;

    const {confirm} = Modal;

    const index = data.findIndex(item => {
        return record.id === item.id;
    });

    if (index !== -1) {
        confirm({
            title: 'Do you want to delete this item?',
            className: darkMode && 'dark-mode',
            content: 'This item will be removed from data source',
            onOk: async () => {
                try {
                    await api.delete(link + "/" + record.id);

                    const newData = [...data];
                    newData.splice(index, 1);
                    message.success({
                        content: "Item successfully deleted.",
                        className: darkMode && "dark-mode"
                    });
                    dispatch({type: GENERIC_CODEBOOK_DELETED, payload: newData})
                } catch (err) {
                    message.error({
                        content: "Item was not deleted.",
                        className: darkMode && "dark-mode"
                    });
                }
            },
            onCancel() {
            }
        });
    } else {
        message.error({
            content: "Record was not deleted.",
            className: darkMode && "dark-mode"
        });
    }
};

export {
    getGenericCodebookData,
    setGenericCodebookOptionsMap,
    setFiltersAndFilterData,
    toggleGenericCodebookAddModal,
    toggleGenericCodebookEditModal,
    saveGenericCodebook,
    updateGenericCodebook,
    onGenericCodebookDelete,
    resetGenericCodebookState
}